import React, { useEffect, useRef } from "react";

import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
// import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { IoMdPrint } from "react-icons/io";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../../_helper/helper";
import { PRINT_ACCESS } from "../../../_contstants/common";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getKarigarWiseBandhaiAmountPhineSummaryReport } from "../services/reports.services";
import { sumBy } from "lodash";

const BandhaiKarigarLedgerReportView: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const fromdate = params.fromdate;
  const todate = params.todate;
  const karigar_id = params.karigar_id;
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.reports.loading);
  const KarigarWiseBandhaiAmountPhineSummaryReportList = useAppSelector(
    (state) => state.reports.KarigarWiseBandhaiAmountPhineSummaryReportList,
  );

  const isPrintAccess = checkAcessRights(
    "/bandhai-karigar-ledger-report",
    PRINT_ACCESS,
  );

  const fetchKarigarWiseBandhaiAmountPhineSummaryReport = async (
    payload: any,
  ) => {
    await dispatch(getKarigarWiseBandhaiAmountPhineSummaryReport(payload));
  };

  useEffect(() => {
    if (fromdate && todate && karigar_id) {
      const payload = {
        karigar_id: karigar_id,
        from_date: fromdate,
        to_date: todate,
      };
      fetchKarigarWiseBandhaiAmountPhineSummaryReport(payload);
    }
  }, []);

  const printTable = () => {
    window.print();
    return;
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <GridLayoutItem>
            <div
              className="printbuttons"
              style={{
                textAlign: "center",
                padding: "20px",
                display: "block",
              }}
            >
              {/* {isExcelExportAccess && (
                <Button
                  type="button"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handleExportExcel}
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                    backgroundColor: "#3b823b",
                  }}
                >
                  <PiMicrosoftExcelLogoFill style={{ fontSize: "20px" }} />{" "}
                  Excel Export
                </Button>
              )} */}
              {isPrintAccess && (
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={printTable}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              )}
            </div>
          </GridLayoutItem>
          <GridLayoutItem>
            <Typography.h5
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              Bandhai Karigar Ledger Report
            </Typography.h5>
            <Typography.h6
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              (
              {fromdate
                ? moment(fromdate, "YYYY-MM-DD").format("DD/MM/YYYY")
                : ""}
              {" to "}
              {todate ? moment(todate, "YYYY-MM-DD").format("DD/MM/YYYY") : ""})
            </Typography.h6>
            <Typography.h5
              style={{
                textAlign: "center",
                fontSize: "18px",
              }}
            >
              Karigar:{" "}
              {
                KarigarWiseBandhaiAmountPhineSummaryReportList?.[0]
                  ?.karigar_name
              }
            </Typography.h5>
          </GridLayoutItem>
          {/* REPORT LIST */}
          {KarigarWiseBandhaiAmountPhineSummaryReportList &&
          KarigarWiseBandhaiAmountPhineSummaryReportList.length > 0 ? (
            <div className="karigar-phine-ledger">
              <div className="table-container">
                <table className="ledger-table">
                  <thead>
                    <tr>
                      <th
                        className="col-date text-center"
                        style={{ width: "10%" }}
                      >
                        Date
                      </th>
                      <th className="col-desc" style={{ width: "20%" }}>
                        Particular
                      </th>
                      <th
                        className="col-issue-net-weight text-end"
                        style={{ width: "10%" }}
                      >
                        Issue Net Weight
                      </th>
                      <th
                        className="col-receipt-amount text-end"
                        style={{ width: "10%" }}
                      >
                        Receipt Amount
                      </th>
                      <th
                        className="col-net-weight text-end"
                        style={{ width: "10%" }}
                      >
                        Receipt Net Weight
                      </th>
                      <th
                        className="col-amount text-end"
                        style={{ width: "10%" }}
                      >
                        Amount
                      </th>
                      <th
                        className="col-phine-balance text-end"
                        style={{ width: "15%" }}
                      >
                        Phine Balance
                      </th>
                      <th
                        className="col-balance text-end"
                        style={{ width: "15%" }}
                      >
                        Balance
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {KarigarWiseBandhaiAmountPhineSummaryReportList.map(
                      (data, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "even-row" : "odd-row"}
                        >
                          <td className="cell-date text-center">
                            {data?.Date}
                          </td>
                          <td
                            className="cell-desc"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {index === 0 ? `Opening Balance` : data?.item_name}
                          </td>
                          <td className="cell-issue-no text-end">
                            {(data?.phine_issue &&
                              formatWeight(data?.phine_issue)) ||
                              ""}
                          </td>
                          <td
                            className="cell-issue"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {formatToIndianCurrencyWithoutSymbol(
                              data?.amount_receipt || 0,
                            )}
                          </td>
                          <td className="cell-issue-no text-end">
                            {(data?.phine_receipt &&
                              formatWeight(data?.phine_receipt)) ||
                              ""}
                          </td>
                          <td
                            className="cell-issue"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {formatToIndianCurrencyWithoutSymbol(
                              data?.amount_issue || 0,
                            )}
                          </td>
                          <td
                            className="cell-receipt"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {formatWeight(data?.closing_phine)}{" "}
                            {data.creditdebittypephine === "Credit"
                              ? "Cr"
                              : "Dr"}
                          </td>
                          <td
                            className="cell-balance"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {formatToIndianCurrencyWithoutSymbol(
                              data?.closing_amount || 0,
                            )}{" "}
                            {data.creditdebittypeamount === "Credit"
                              ? "Cr"
                              : "Dr"}
                          </td>
                        </tr>
                      ),
                    )}
                  </tbody>
                  <tfoot>
                    <tr className="totals-row">
                      <td colSpan={2} className="totals-label">
                        TOTALS
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseBandhaiAmountPhineSummaryReportList,
                            "phine_issue",
                          )
                        )}
                      </td>
                      <td className="total-receipt text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          sumBy(
                            KarigarWiseBandhaiAmountPhineSummaryReportList,
                            "amount_receipt",
                          ),
                        )}
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseBandhaiAmountPhineSummaryReportList,
                            "phine_receipt",
                          )
                        )}
                      </td>
                      <td className="total-receipt text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          sumBy(
                            KarigarWiseBandhaiAmountPhineSummaryReportList,
                            "amount_issue",
                          ),
                        )}
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          ) : null}
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default BandhaiKarigarLedgerReportView;
